/** Evenly thin a series to at most `max` points so long windows stay legible. */
export function downsample(values: number[], max = 24): number[] {
  if (values.length <= max) return values;
  const step = (values.length - 1) / (max - 1);
  return Array.from(
    { length: max },
    (_, i) => values[Math.round(i * step)] ?? 0,
  );
}
